import { emitter } from '@marvelapp/react-ab-test';

import data from '../../models/data';
import { WelcomeSplashVariant } from '../../interfaces/WelcomeSplashVariant';

export const WELCOME_SEEN_PARAM = 'welcome_seen';
export const AFTER_WELCOME_PARAM = 'after_welcome';
const WELCOME_SPLASH_TEST = 'WelcomeSplash';

interface DecideWelcomeSplashVariantParams {
  email: string;
}

export function decideWelcomeSplashVariant({
  email
}: DecideWelcomeSplashVariantParams): WelcomeSplashVariant {
  if (!isWelcomeEnabledForClient()) return WelcomeSplashVariant.SKIP;

  emitter.defineVariants(
    WELCOME_SPLASH_TEST,
    [WelcomeSplashVariant.SHOW, WelcomeSplashVariant.SKIP],
    [50, 50]
  );
  let currentVariant: WelcomeSplashVariant;

  // We use email if available to provide a stable experience across different devices
  // However if there's no email we pass nothing, otherwise an empty string defaults to SHOW
  // It's still consistent on the same device because the result is persisted to localStorage
  if (email) {
    currentVariant = emitter.calculateActiveVariant(
      WELCOME_SPLASH_TEST,
      email
    ) as WelcomeSplashVariant;
  } else {
    currentVariant = emitter.calculateActiveVariant(
      WELCOME_SPLASH_TEST
    ) as WelcomeSplashVariant;
  }

  return currentVariant;
}

export function isWelcomeEnabledForClient() {
  const {
    featureFlags: { welcomeSplashClients, welcomeSplashEnabled },
    clientApp: { uid: clientUid },
    cobrandClientApp: { uid: cobrandClientUid }
  } = data;
  if (!welcomeSplashEnabled) return false;
  if (clientUid === '' && cobrandClientUid === '') return false;

  return (
    welcomeSplashClients.includes(clientUid) ||
    welcomeSplashClients.includes(cobrandClientUid)
  );
}
